var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import useUserSesssion from './use-user-session';
import { useEffect, useState } from 'react';
import { makeRemoteManageActivities } from '@/main/factories/usecases/manage-activities/manage-activities-factory';
const service = makeRemoteManageActivities(); // Perhaps it would be better to consider making this a hook parameter.
function useValidateUserActivity(activityName) {
    const [isLoading, setIsLoading] = useState(true);
    const [isAllowed, setIsAllowed] = useState(false);
    const { user } = useUserSesssion();
    const initData = () => __awaiter(this, void 0, void 0, function* () {
        if ((user === null || user === void 0 ? void 0 : user.id) && activityName) {
            const allowed = yield service.validateUserActivity({
                idUser: user === null || user === void 0 ? void 0 : user.id,
                activityName
            });
            setIsAllowed(allowed);
            setIsLoading(false);
        }
    });
    useEffect(() => {
        initData();
    }, [user === null || user === void 0 ? void 0 : user.id, activityName]);
    return { isAllowed, isLoading };
}
export default useValidateUserActivity;
